import { useEffect, useState, useContext, useRef } from "react";

import stylesRequestData from "../../UnifiedTaxDeclarationRequestData/index.module.css";
import SearchSelectElement from "../../../../shared/form/SearchSelectElement";
import {
  getDeclerationDistricts,
  getDeclerationVillages,
  getDeclerationRegions,
  getDeclerationRealEstates,
  getDeclerationFloorsByRealEstateId,
  getMapGovernorates,
} from "../../../../adapters/apis/lookups/lookups";
import InputElement from "../../../../shared/form/InputElement";
import UnifiedTaxDeclarationContext from "../../../../contexts/UnifiedTaxDeclarationProvider";
import FieldRenderer from "../common/FieldRendrer";
import TextAreaElement from "../../../../shared/form/TextAreaElement";
import CommonAddressMap from "../../../../shared/pages/map/CommonAddressMap";
import { validateRequired } from "../../../../helpers/Validation";
import { getMatchingBuildings } from "../../helpers/commonValidation";

const CommonAddressForm = ({
  generateOptions,
  govs,
  error_new_user,
  setError,
  setValidFields,
  setUploadFileError,
  setFloors,
  setUnits,
  setNewUserError,
  handleChangeDeclerationUnit,
  unitBuildingMapError,
  unitMapError,
  setUnitMapError,
}) => {
  const unifiedTaxDeclarationContext = useContext(UnifiedTaxDeclarationContext);
  const {
    declarationRequest,
    setDeclarationRequest,
    isUnitInSameBuilding,
    setGovs,
    searchUsingTypes,
    building,
    mapEnabled,
  } = unifiedTaxDeclarationContext;

  const [districts, setDistricts] = useState([]);
  const [villages, setVillages] = useState([]);
  const [regions, setRegions] = useState([]);
  const [realEstates, setRealEstates] = useState([]);

  const customFilter = (candidate, input) => {
    const lowerCaseInput = input.toLowerCase();
    const lowerCaseLabel = candidate.label.toLowerCase();

    return lowerCaseLabel.includes(lowerCaseInput);
  };

  useEffect(() => {
    setDeclarationRequest((prev) => ({
      ...prev,
      unit: {
        ...prev?.unit,
        search_using: 1,
        filter_search_type_id: declarationRequest?.unit?.id
          ? declarationRequest?.unit?.filter_search_type_id
          : mapEnabled
            ? 1
            : 3,
      },
    }));
  }, []);

  useEffect(() => {
    const newNum = declarationRequest?.unit?.known_build_num;
    const buildings = declarationRequest?.unit?.buildings;

    // if (!newNum) return;

    setDeclarationRequest((prev) => {
      const updatedBuildings = buildings?.map((b) =>
        parseInt(b?.main_building) === 1
          ? { ...b, known_build_num: newNum }
          : b,
      );

      return {
        ...prev,
        unit: {
          ...prev.unit,
          buildings: updatedBuildings,
        },
      };
    });
  }, [declarationRequest?.unit?.known_build_num]);

  const isViewMode =
    declarationRequest?.viewMode || declarationRequest?.isUnitViewMode;

  const hasAdditionalAddressInfo = Boolean(
    declarationRequest?.unit?.address_additional_info?.trim(),
  );

  const shouldShowAdditionalInfoField = !isViewMode || hasAdditionalAddressInfo;

  return (
    <>
      <div
        className="col-lg-12 col-sm-12"
        style={{ clear: "both", marginTop: "16px" }}
      >
        <CommonAddressMap
          hasNoContainer={true}
          mapType={"unit"}
          NoRender={false}
          unitMapError={unitMapError}
          setUnitMapError={setUnitMapError}
          numberOfBuildings={getMatchingBuildings(declarationRequest)?.length}
        />
      </div>

      {parseInt(declarationRequest?.unit?.is_map_address_matching) === 2 &&
        parseInt(declarationRequest?.unit?.filter_search_type_id) !== 3 &&
        declarationRequest?.unit?.mismatch_reason_id !== null &&
        !declarationRequest?.viewMode && (
          <div className="col-lg-4 col-sm-6">
            <InputElement
              mb4="mb-4"
              labelHtmlFor="known_build_num"
              labelClassName={` ${stylesRequestData["form-label"]} form-label ${!validateRequired(declarationRequest?.unit?.buildingProfile?.number) && "required"}`}
              labelText="رقم العقار/المبنى المتعارف عليه"
              inputType="text"
              maxLength={100}
              inputClassName={`${stylesRequestData["form-control"]} form-control`}
              inputID="known_build_num_input"
              name="known_build_num"
              pClassName="text-danger mb-0 mt-2 me-2 fw-bolder"
              value={declarationRequest?.unit?.known_build_num || ""}
              allowedPattern={
                /^(?!0)[A-Za-z\u0621-\u063A\u0641-\u064A0-9\-_,.\/\\\s]+$/
              }
              onChange={handleChangeDeclerationUnit}
              pText={error_new_user.known_build_num}
              disabled={
                declarationRequest?.viewMode ||
                declarationRequest?.isUnitViewMode ||
                isUnitInSameBuilding
              }
            />
          </div>
        )}

      {shouldShowAdditionalInfoField && (
        <div className="">
          <div className="pr-3 mt-3 mt-sm-1">
            <TextAreaElement
              mb4="mb-4"
              labelHtmlFor="address_additional_info"
              labelClassName={` form-label ${stylesRequestData["form-label"]}`}
              labelText="معلومات إضافية لوصف عنوان العقار"
              inputClassName={`required ${stylesRequestData["form-control"]} form-control w-100`}
              inputType="text"
              teaxtAreaID="address_additional_info"
              teaxtAreaClassName="form-control"
              pClassName="text-danger mb-0 mt-2 me-2 fw-bolder"
              inputId="address_additional_info_input"
              pText={error_new_user.address_additional_info}
              value={declarationRequest?.unit?.address_additional_info || ""}
              onChange={handleChangeDeclerationUnit}
              name="address_additional_info"
              disabled={
                declarationRequest?.viewMode ||
                declarationRequest?.isUnitViewMode ||
                isUnitInSameBuilding
              }
              allowedPattern={
                /^[A-Za-z\u0621-\u063A\u0641-\u064A0-9\-_,.@\/\\\s]+$/
              }
              maxLength={3000}
            />
          </div>
        </div>
      )}
    </>
  );
};

export default CommonAddressForm;
